import React from 'react';

export const PendingSvg = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.29169 4.375V7.29167L9.62502 9.625"
      stroke="currentColor"
      strokeOpacity="0.6"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.02181 0.950684L1.59656 4.33227L3.25672 3.86968L4.91689 3.4071"
      stroke="currentColor"
      strokeOpacity="0.6"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.59658 4.33245C2.31945 2.9399 3.52747 1.86046 4.99225 1.29822C6.45704 0.735973 8.07706 0.72989 9.54602 1.28112C11.015 1.83235 12.2311 2.90268 12.9644 4.28976C13.6977 5.67684 13.8974 7.28452 13.5257 8.80884C13.154 10.3332 12.2367 11.6685 10.9472 12.5623C9.65772 13.4562 8.08544 13.8466 6.52762 13.6598C4.9698 13.4729 3.53441 12.7218 2.49284 11.5484C1.45128 10.375 0.875724 8.86068 0.875 7.2917"
      stroke="currentColor"
      strokeOpacity="0.6"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
  </svg>
);
